import { saveReservation } from "@/services/reservationService";
import React, { useState, FormEvent, ChangeEvent } from "react";

interface FormData {
  fullName: string;
  phone: string;
  email: string;
  reservationDate: string;
  people: number;
  message: string;
  newsletter: boolean;
  siteName: string;
}
interface ReservationFormProps {
  siteName: string;
}

const ReservationForm: React.FC<ReservationFormProps> = ({ siteName }) => {
  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    phone: "",
    email: "",
    reservationDate: "",
    people: 1,
    message: "",
    newsletter: false,
    siteName: siteName,
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    fullName: "",
    phone: "",
    email: "",
    reservationDate: "",
    people: "",
  });

  const validate = () => {
    let newErrors = {
      fullName: "",
      phone: "",
      email: "",
      reservationDate: "",
      people: "",
    };
    let isValid = true;

    if (!formData.fullName) {
      newErrors.fullName = "Name is required";
      isValid = false;
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    }
    if (!formData.phone) {
      newErrors.phone = "Phone is required";
      isValid = false;
    }
    if (!formData.reservationDate) {
      newErrors.reservationDate = "Reservation date is required";
      isValid = false;
    }

    if (!formData.people) {
      newErrors.people = "1 person at least is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const target = e.target as HTMLInputElement; // Casting here for `checked`
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);

    try {
      // Funny alert easter egg
      alert("Really, you think you are smart!!");
      return;
      // await saveReservation(formData);
      // setSubmitted(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
      setFormData({
        fullName: "",
        phone: "",
        email: "",
        reservationDate: "",
        people: 1,
        message: "",
        newsletter: false,
        siteName: siteName,
      });
    }
  };

  return (
    <>
      <form
        className="flex flex-col pointer-events-none opacity-50"
        onSubmit={handleSubmit}
      >
        <div className="mb-4">
          <label
            htmlFor="fullName"
            className="text-gray-700 text-sm font-semibold"
          >
            Full name
          </label>
          <input
            id="fullName"
            className="w-full p-2 mt-2 h-[53px]"
            type="text"
            placeholder=""
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && (
            <p className="text-red-500 text-xs italic mt-1">
              {errors.fullName}
            </p>
          )}
        </div>
        <div className="flex gap-4 mb-4">
          <div className="flex-1">
            <label
              htmlFor="phone"
              className="text-gray-700 text-sm font-semibold"
            >
              Phone
            </label>
            <input
              id="phone"
              className="w-full p-2 mt-2 h-[53px]"
              type="tel"
              placeholder=""
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
            {errors.phone && (
              <p className="text-red-500 text-xs italic mt-1">{errors.phone}</p>
            )}
          </div>
          <div className="flex-1">
            <label
              htmlFor="email"
              className="text-gray-700 text-sm font-semibold"
            >
              Email
            </label>
            <input
              id="email"
              className="w-full p-2 mt-2 h-[53px]"
              type="email"
              placeholder=""
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && (
              <p className="text-red-500 text-xs italic mt-1">{errors.email}</p>
            )}
          </div>
        </div>
        <div className="flex gap-4 mb-4">
          <div className="flex-1">
            <label
              htmlFor="reservationDate"
              className="text-gray-700 text-sm font-semibold"
            >
              Date/Reservation hours
            </label>
            <input
              id="reservationDate"
              className="w-full p-2 mt-2 h-[53px]"
              type="datetime-local"
              placeholder=""
              name="reservationDate"
              value={formData.reservationDate}
              onChange={handleChange}
            />
            {errors.reservationDate && (
              <p className="text-red-500 text-xs italic mt-1">
                {errors.reservationDate}
              </p>
            )}
          </div>
          <div className="flex-1">
            <label
              htmlFor="people"
              className="text-gray-700 text-sm font-semibold"
            >
              People
            </label>
            <input
              id="people"
              className="w-full p-2 mt-2 h-[53px]"
              type="number"
              placeholder=""
              name="people"
              min={1}
              max={100}
              value={formData.people}
              onChange={handleChange}
            />
            {errors.people && (
              <p className="text-red-500 text-xs italic mt-1">
                {errors.people}
              </p>
            )}
          </div>
        </div>
        <div className="mb-1">
          <label
            htmlFor="message"
            className="text-gray-700 text-sm font-semibold"
          >
            Message
          </label>
          <textarea
            id="message"
            className="w-full p-2 mt-1 h-[142px]"
            placeholder=""
            name="message"
            rows={6}
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="mt-12 mb-8">
          <button
            className={`w-full bg-[#03BC6E] hover:bg-green-500 text-[12px] text-white font-semibold py-2 px-4 h-[58px] ${
              isSubmitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "SUBMIT"}
          </button>
        </div>
        <div className="flex items-center">
          <input
            id="newsletter"
            type="checkbox"
            className="mr-2"
            name="newsletter"
            checked={!!formData.newsletter}
            onChange={handleChange}
          />
          <label htmlFor="newsletter" className="text-gray-800 text-[12px]">
            I agree to receive the newsletter from QrMenu
          </label>
        </div>
        <p className="text-gray-500 text-[12px] mt-4">
          Your contact details remain confidential and will not be transmitted
          under any circumstances, in accordance with the Data Protection Act.
        </p>
      </form>
      {submitted && (
        <div
          className="fixed inset-0 bg-white bg-opacity-75 flex justify-center items-center"
          onClick={() => setSubmitted(false)}
        >
          <div
            id="alert-additional-content-1"
            className="p-4 mb-4 mx-5 text-green-800 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400 dark:border-green-800"
            role="alert"
            onClick={(e) => e.stopPropagation()} // Prevent click from bubbling to the overlay
            style={{ minWidth: "300px", maxWidth: "500px" }} // Ensure the modal is not too small
          >
            <div className="flex items-center">
              <svg
                className="flex-shrink-0 w-5 h-5 mr-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 className="text-lg font-medium">Reservation Confirmed!</h3>
            </div>
            <div className="mt-2 mb-4 text-sm">
              Your reservation has been successfully confirmed. We look forward
              to welcoming you. If you have any questions or need to make
              changes to your reservation, please contact us.
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                className="text-green-800 bg-transparent border border-green-800 hover:bg-green-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-xs px-4 py-2 text-center dark:hover:bg-green-600 dark:border-green-600 dark:text-green-400 dark:hover:text-white dark:focus:ring-green-800"
                onClick={() => setSubmitted(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReservationForm;
